// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"82e90d40","453":"fded7a2b","455":"919bf6bb","977":"f020ff46"}[chunkId] + ".chunk.js";
};